export default __webpack_public_path__ + "static/media/facebook-color.436092d7.svg";